import Model from '@/models/Model'
import { numberFormatter } from '../../services/JSUtils'

export default class SlSaleCreditNote extends Model {
    get name_case() {
        return `N° ${this.number} - $ ${this.total}`
    }
    resource() {
        return 'sl_sale_credit_note'
    }

    downloadPdf() {
        return new Promise((resolve, reject) =>
            this.$http
                .get(
                    process.env.VUE_APP_API_ROUTE +
                        '/sl_sale_credit_note/' +
                        this.id +
                        '/pdf',
                    { responseType: 'blob' }
                )
                .then(response => {
                    const linkSource = URL.createObjectURL(response.data)
                    const downloadLink = document.createElement('a')
                    const fileName = `${this.number}-NOTA_DE_CREDITO_ELECTRONICA.pdf`
                    downloadLink.href = linkSource
                    downloadLink.download = fileName
                    downloadLink.click()
                    resolve()
                })
                .catch(reject)
        )
    }

    get isInvoiceCreditNote() {
        return (
            !!this.sl_service_order &&
            !!this.sl_service_order.sl_sale_invoice_id
        )
    }

    ticketHtmlPrintByNumber(number, companyData = {}, officeData = {}) {
        return new Promise((res, rej) => {
            this.include(
                'sl_detail_sale_credit_notes.wh_product',
                'sl_service_order.sl_sale_ticket_affected'
            )
                .where('number', number)
                .first()
                .catch(rej)
                .then(creditNote =>
                    creditNote.ticketHtmlPrint(companyData, officeData)
                )
        })
    }

    get referencedDte() {
        if (
            this.sl_service_order &&
            this.sl_service_order.sl_sale_ticket_affected
        )
            return this.sl_service_order.sl_sale_ticket_affected
        if (
            this.sl_service_order &&
            this.sl_service_order.sl_sale_invoice_affected
        )
            return this.sl_service_order.sl_sale_invoice_affected
        return null
    }

    getReferencedDteProp(propName) {
        if (!this.referencedDte) return null
        return this.referencedDte[propName]
    }

    /**
     * 
     */
    printHtml = (company, office) => {
        return this.ticketHtmlPrint(company, office)
    }

    ticketHtmlPrint(companyData = {}, officeData = {}) {
        let {
            business_name,
            commercial_business,
            address,
            rut,
            sii_resolution_month,
            sii_resolution_year,
        } = companyData
        let { officeId, officeName, officeCashDeskId } = officeData
        console.log('RECOVERED NC', this)
        let obj = {}
        obj.eSignatureURL = this.signature_url
        obj.title = business_name
        //obj.subtitle = 'BOLETA N°123' // después hacer que reciba n° de boleta como parámetro
        obj.barcode = '123456789012'
        obj.RUT = rut
        obj.creditNoteNum = this.number
        obj.activities = commercial_business
        obj.address = address
        obj.phone = ''
        obj.seller = null
        obj.date = this.created_at.split(' ')[0]
        obj.time = this.created_at.split(' ')[1]
        obj.preventPrint = localStorage.getItem('_prevent_print')
        obj.closeTimeout = process.env.VUE_APP_PRINTER_TIMEOUT
        obj.amountPaid = '2222' //infoSale
        obj.change = 0 //infosale
        //obj.discount = 10 //infosale
        // determinando si es boleta o factura
        obj.posSaleType = 1
        obj.creditNote = 'NOTA DE CREDITO ELECTRÓNICA'
        obj.netTotal = this.net_total
        obj.iva = this.iva
        obj.total = this.total
        obj.annulNumber = this.getReferencedDteProp('number')
        obj.dateCreatedAnnul = this.getReferencedDteProp('created_at')
        //Info Sucursal
        obj.officeID = officeId
        obj.officeName = officeName
        obj.cashDesk = officeCashDeskId
        if (this.supervisor) {
            obj.supervisorName = this.supervisor.name // después recibir de algún otro store
            obj.supervisorID = this.supervisor.id // después recibir de algún otro store
        }
        obj.items = this.sl_detail_sale_credit_notes
        obj.resNumber = sii_resolution_month
        obj.resYear = sii_resolution_year
        let win = window.open('creditNote.html')
        Object.assign(win.window, obj)
    }

    getByNumber(number) {
        return new Promise((resolve, reject) =>
            this.where('number', number)
                .first()
                .then(resolve)
                .catch(reject)
        )
    }

    get formattedTotalInvoice() {
        return (
            '$' + numberFormatter(parseInt(this.net_total) + parseInt(this.iva))
        )
    }

    get formattedTotalTicket() {
        return '$' + numberFormatter(parseInt(this.total))
    }

    get formattedTotal() {
        return this.isInvoiceCreditNote
            ? this.formattedTotalInvoice
            : this.formattedTotalTicket
    }

    get affectedDocTypeName() {
        return this.isInvoiceCreditNote ? 'Factura' : 'Boleta'
    }

    get ticketNumber() {
        return this.sl_service_order &&
            this.sl_service_order.sl_sale_ticket_affected
            ? this.sl_service_order.sl_sale_ticket_affected.number
            : null
    }

    get invoiceNumber() {
        return this.sl_service_order &&
            this.sl_service_order.sl_sale_invoice_affected
            ? this.sl_service_order.sl_sale_invoice_affected.number
            : null
    }

    get affectedDocNumber() {
        return this.isInvoiceCreditNote ? this.invoiceNumber : this.ticketNumber
    }

    get customerName() {
        return this.sl_customer ? this.sl_customer.alias_name : null
    }

    get customerOfficeText() {
        return this.sl_customer_branch_offices
            ? this.sl_customer_branch_offices.address +
                  (this.sl_customer_branch_offices.city
                      ? ` - ${this.sl_customer_branch_offices.city}`
                      : '')
            : null
    }

    /**
     * 
     */
    get slSalePaymentsDetail() {
        return [
            {
                method      : `${ this.affectedDocTypeName }`,
                amount      : parseFloat(this.total),
                description : `N° ${ this.ticketNumber }`,
            }
        ]
    }

    /**
     * 
     */
    get slSaleProductsDetail() {
        return this.sl_detail_sale_credit_notes.map(this.mapSlSaleProducts)
    }

    /**
     * 
     */
    mapSlSaleProducts(item) {
        return {
            discount_line_amount: item.discount_or_charge_value,
            discount_percentage : item.discount_or_charge_percentage,
            price               : item.price,
            product_name        : item.wh_product.name,
            quantity            : item.quantity,
            sub_total           : item.subtotal,
        }
    }
}
